import React, { useEffect, useState } from "react";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { IoSearch } from "react-icons/io5";
import { FaRegCircleUser } from "react-icons/fa6";
import GymTable from "../components/GymTable";
import axios from "axios";
import API_URL from "../config";
import { useAdmin } from "../contexts/AdminContext";
import Loading from "../components/Loading";

const GSTInvoiceandAgreement = () => {
  const { admin } = useAdmin();
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsersByBranch = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/auth/branch/${admin?.branch}`
        );
        const sortedUsers = response.data.sort((a, b) => {
          return parseInt(a.memberId) - parseInt(b.memberId);
        });

        setUsers(sortedUsers);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsersByBranch();
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredUsers = users.filter(
    (user) =>
      user.fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.memberId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.phoneNo.includes(searchTerm)
  );

  return (
    <div className="exerciseManagementContainer">
      <div className="userManagementHeader">
        <div className="userHeaderLeft">
          <LiaFileInvoiceDollarSolid
            size={30}
            color="#ff0000"
            style={{ marginRight: 10 }}
          />
          <h2>Gst invoice and aggrement</h2>
        </div>
        <div className="userHeaderRight">
          <input
            placeholder="eg. Search by memberId name, phone"
            onChange={handleSearchChange}
          />
          <div>
            <IoSearch />
          </div>
        </div>
        <div className="addUserBtn">
          <FaRegCircleUser />
          <p>Add User</p>
        </div>
      </div>
      {loading ? (
        <Loading />
      ) : (
        <GymTable data={filteredUsers} isInvoice={true} isAgreement={true} />
      )}
    </div>
  );
};

export default GSTInvoiceandAgreement;
